export default "__VITE_ASSET__BsTZeXvY__"